import { csx, cx } from '@vtex/admin-ui'
import { styles } from './styles'

type Props = {
  percentage: number
  disabled?: boolean
}

export function ProgressBar(props: Props) {
  const { percentage, disabled } = props

  const value = percentage % 100

  const isFinished = percentage >= 100

  return (
    <div className={styles.background(isFinished)} aria-disabled={disabled}>
      <div
        role="progressbar"
        aria-valuenow={value}
        aria-valuemin={0}
        aria-valuemax={100}
        className={cx(
          styles.bar(disabled ?? false),
          csx({ width: `${value}%` })
        )}
      />
    </div>
  )
}
